export default () => ({
  show: false,
  isLoading: true,
  onCancel: false,
  fullPage: true,
  garages: [],
  living: {
    tower_id: null,
    unit_id: null,
    people_name: null,
    people_id: null,
    people_email: null,
    phone: null,
    status: true,
    access: false
  },
  livings: [],
  entity: 'living',
  entities: 'livings',
  dwellerUnits: [],
  dwellerTowers: [],
  optionTowers: [],
  optionStatus: [
    {
      id: true,
      label: 'Ativo'
    },
    {
      id: false,
      label: 'Inativo'
    }
  ],
  config: {
    sideBySide: true,
    useCurrent: false,
    locale: 'pt-br',
    format: 'DD/MM/YYYY',
    widgetPositioning: {
      horizontal: 'left',
      vertical: 'bottom'
    }
  },
  prefixRouter: 'dweller.livings'
})



// WEBPACK FOOTER //
// ./src/app/dweller/livings/resources/data.js